import React from 'react';

import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const SalesConversionChart = ({ revenueData = {}, height = 300 }) => {
  const formatRevenueData = (revenueData) => {
    if (!revenueData || Object.keys(revenueData).length === 0) return [];

    return Object.entries(revenueData)
      .filter(([, revenue]) => revenue && revenue > 0)
      .map(([department, revenue]) => ({
        name: department,
        amount: revenue,
      }))
      .sort((a, b) => b.amount - a.amount)
      .slice(0, 10);
  };

  const chartData = formatRevenueData(revenueData);

  return (
    <ResponsiveContainer width="100%" height={height} minHeight={250}>
      <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey="name" tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip
          content={({ payload, label }) => {
            if (!payload || payload.length === 0) return null;
            return (
              <div
                style={{
                  background: 'white',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  fontSize: '12px',
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: '#333',
                    fontWeight: 'bold',
                    fontSize: '12px',
                  }}
                >
                  {label}
                </p>
                {payload.map((entry, index) => (
                  <p
                    key={index}
                    style={{ margin: '2px 0', color: entry.color, fontSize: '11px' }}
                  >
                    {entry.value?.toLocaleString()} AMD
                  </p>
                ))}
              </div>
            );
          }}
        />
        <Bar dataKey="amount" fill="#67C8EB" name="Revenue" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SalesConversionChart;
